import React, { useEffect, useState } from "react";
import "./Lists.css";
import "../common.css";
import { getLists } from "../api";
import {
  Container,
  Row,
  Col,
  Image,
  ListGroup,
  Badge,
  Alert,
  Spinner,
} from "react-bootstrap";
import readingTime from "../assets/reading-time.svg";
import SearchBar from "../components/SearchBar";
import { FaFileCirclePlus, FaLock } from "react-icons/fa6";
import { FaCopy } from "react-icons/fa";
import { buildDateStringElement, buildDateString } from "../utils";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";

function Lists() {
  const [lists, setLists] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingData, setLoadingData] = useState(true);
  const [loadingImg, setLoadingImg] = useState(true);
  const [showAlert, setShowAlert] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (showAlert) {
      timer = setTimeout(() => setShowAlert(false), 1000);
    }
    return () => clearTimeout(timer);
  }, [showAlert]);

  useEffect(() => {
    const handleApiCalls = async () => {
      try {
        setLoadingData(true);
        const fetchedLists = await getLists();
        setLists(fetchedLists);
      } catch (error) {
        console.error("Error fetching lists:", error);
      } finally {
        setLoadingData(false);
      }
    };
    handleApiCalls();
  }, []);

  const goToCreateNewRanking = () => {
    navigate("/create-new-ranking");
  };

  const copyLink = (event, list) => {
    event.stopPropagation();
    const currUrl = `${window.location.href}${list.created}`;
    navigator.clipboard
      .writeText(currUrl)
      .then(() => {
        setShowAlert(true);
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err);
      });
  };

  const RankingLists = () => {
    return (
      <div>
        {showAlert && (
          <Alert className="overlayAlert">Link copied to clipboard!</Alert>
        )}
        <ListGroup>
          {lists
            .filter((list) =>
              buildDateString(list.created)
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            )
            .sort((a, b) => new Date(b.created) - new Date(a.created))
            .map((list) => (
              <ListGroup.Item
                key={list.created}
                action
                onClick={() => navigate(`/${list.created}`)}
                className="d-flex justify-content-between"
              >
                <div>{buildDateStringElement(new Date(list.created))}</div>
                {list.closed && (
                  <Badge className="accordion-badge-2">
                    <FaLock />
                  </Badge>
                )}
                <Badge
                  className="accordion-badge"
                  onClick={(event) => copyLink(event, list)}
                >
                  <FaCopy />
                </Badge>
              </ListGroup.Item>
            ))}
        </ListGroup>
      </div>
    );
  };

  const pageImage = (
    <Image
      src={readingTime}
      className="main-picture"
      onLoad={() => {
        if (loadingImg) {
          setLoadingImg(false);
        }
      }}
    />
  );

  if (loadingImg) {
    return <Loading pageImage={pageImage} />;
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="centered-container">{pageImage}</div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="title">Book Lists</div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <Row>
            <Col xs={10}>
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </Col>
            <Col xs={2}>
              <div className="new-list-container">
                <FaFileCirclePlus
                  size={"28"}
                  onClick={goToCreateNewRanking}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-4 mb-5">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          {(loadingData && (
            <div className="centered-container">
              <Spinner animation="border" />
            </div>
          )) ||
            (lists.length > 0 && <RankingLists />) || (
              <Alert className="info-alert">
                <div>There are currently no book lists in the database.</div>
                <div className="mt-3">
                  Start creating a new book list by pressing the icon above.
                </div>
              </Alert>
            )}
        </Col>
      </Row>
    </Container>
  );
}

export default Lists;
